
import fieldMixin from "@/mixins/field"

export default {
  mixins: [fieldMixin],

  props: {
    label: { type: String, required: true },
    help: { type: String, default: "" },
  },

  computed: {
    model: {
      get () { return this.normalize(this.value) },
      set (model) {
        this.$emit("input", this.normalize(model))
        this.$emit("update:error", "")
      },
    },
  },

  methods: {
    normalize (value) {
      if (value === "true") return true
      if (value === "false") return false
      return value
    },
  },
}
